import { useContext } from 'react';
import { VerificationContext } from '../context';

export function useVerifications() {
    const context = useContext(VerificationContext);
    return { ...context };
}
